var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderAlignmentStretch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3C2.77614 3 3 3.22386 3 3.5V20.5C3 20.7761 2.77614 21 2.5 21C2.22386 21 2 20.7761 2 20.5V3.5C2 3.22386 2.22386 3 2.5 3ZM22.5 3C22.7761 3 23 3.22386 23 3.5V20.5C23 20.7761 22.7761 21 22.5 21C22.2239 21 22 20.7761 22 20.5V3.5C22 3.22386 22.2239 3 22.5 3ZM20 13.5C20.2761 13.5 20.5 13.7239 20.5 14V19C20.5 19.2761 20.2761 19.5 20 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V14C4.5 13.7239 4.72386 13.5 5 13.5H20ZM5.5 18.5H19.5V14.5H5.5V18.5ZM20 4.5C20.2761 4.5 20.5 4.72386 20.5 5V10C20.5 10.2761 20.2761 10.5 20 10.5H5C4.72386 10.5 4.5 10.2761 4.5 10V5C4.5 4.72386 4.72386 4.5 5 4.5H20ZM5.5 9.5H19.5V5.5H5.5V9.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderAlignmentStretch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/builder-alignment-stretch.0a28b4095208117e8b1671a679cf871d.svg";